
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Dexie from 'dexie';
import API_CONFIG2 from '../components/API_CONFIG/API_CONFIG2';

// Composants de layout (ceux de votre application)
import CunstomCandidatProfil from '../components/maketApp/layout/CunstomCandidatProfil';

// Configuration Dexie (nom différent pour éviter les conflits)
const db = new Dexie('AppCache');
db.version(1).stores({
  userCache: 'id' // l'id correspondra au userId
});

const CACHE_DURATION = 24 * 60 * 60 * 1000; // 24 heures

const CandidatProfils = () => {
  const [userId, setUserId] = useState(null);
  const [userData, setUserData] = useState(null);

  // 1. Récupération de l'userId depuis localStorage (une seule fois au montage)
  useEffect(() => {
    const storedUserId = localStorage.getItem('userId');
    if (storedUserId) {
      setUserId(storedUserId);
    } else {
      console.warn('userId introuvable dans localStorage.');
    }
  }, []);

  // 2. Chargement des données utilisateur avec cache Dexie + fallback 429
  useEffect(() => {
    if (!userId) return;

    const fetchUserData = async () => {
      // --- Étape 1 : Vérifier le cache Dexie (avec timestamp) ---
      try {
        const cached = await db.userCache.get(userId);
        if (cached && Date.now() - cached.timestamp < CACHE_DURATION) {
          // Cache frais → on l'utilise
          setUserData(cached.data);
          localStorage.setItem('userData', JSON.stringify(cached.data));
          return;
        }
      } catch (error) {
        console.warn('Erreur de lecture du cache Dexie :', error);
      }

      // --- Étape 2 : Appel API ---
      try {
        const response = await axios.get(
          `${API_CONFIG2.apiUrl}getUserInfo.php?userId=${userId}`
        );

        if (response.data) {
          // Si l'API renvoie un statut 0 (désactivé), on peut gérer ici
          // (ici on laisse le useEffect suivant gérer le statut)
          setUserData(response.data);
          localStorage.setItem('userData', JSON.stringify(response.data));

          // Sauvegarde dans Dexie avec timestamp
          await db.userCache.put({
            id: userId,
            data: response.data,
            timestamp: Date.now()
          });
        } else {
          console.warn('Données utilisateur introuvables dans la réponse API.');
        }
      } catch (error) {
        console.error('Erreur lors de la récupération des informations utilisateur :', error);

        // --- Étape 3 : Gestion de l'erreur 429 (trop de requêtes) ---
        if (error.response?.status === 429) {
          console.warn('Trop de requêtes (429). Utilisation du cache périmé si disponible.');
          try {
            const fallbackCache = await db.userCache.get(userId);
            if (fallbackCache) {
              setUserData(fallbackCache.data);
              localStorage.setItem('userData', JSON.stringify(fallbackCache.data));
            } else {
              // Aucun cache, on réessaie après 30 secondes
              setTimeout(fetchUserData, 30000);
            }
          } catch (dexieError) {
            console.error('Impossible de lire le cache fallback :', dexieError);
          }
        }
        // Pour les autres erreurs, on peut laisser userData à null (rien ne s'affiche)
      }
    };

    fetchUserData();
  }, [userId]);

  // 3. Surveillance du statut (désactivation du compte)
  useEffect(() => {
    if (userData && userData.status === 0) {
      console.log('Statut utilisateur désactivé. Suppression de la session.');
      localStorage.removeItem('login');
      window.location.reload(); // ou navigate('/') selon votre choix
    }
  }, [userData]);

  // 4. Rendu : affichage conditionnel direct (comme dans le deuxième code)
  return (
    <div className="adminx-container">
      {userData?.fonction === 'SUPER ADMIN' && (
        <CunstomCandidatProfil userId={userId} fonction={userData.fonction} />
      )}
      {userData?.fonction === 'DSI' && (
        <CunstomCandidatProfil userId={userId} fonction={userData.fonction} />
      )}
       {userData?.fonction === 'RH' && (
        <CunstomCandidatProfil userId={userId} fonction={userData.fonction} />
      )}

    
      
      
      {/* Si aucun rôle ne correspond, on n'affiche rien (ou un message optionnel) */}
      {userData && !['SUPER ADMIN','DSI','RH','FORMATEUR','COMPTABLE','CAISSIER'].includes(userData.fonction) && (
        <div className="text-center mt-5 text-dark">
          Rôle non reconnu ou accès non autorisé. (Fonction : {userData.fonction})
        </div>
      )}
    </div>
  );
};

export default CandidatProfils;